// extractWebAppUrl turns a WebApplication asset.key into the primary URL.
// Key format: "#webapplication#<primaryURL>" — split on '#' and grab the
// last segment. Returns "" for keys that don't match.
export function extractWebAppUrl(assetKey: string): string {
  if (!assetKey.startsWith('#webapplication#')) return '';
  return assetKey.slice('#webapplication#'.length);
}
